import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { IdentityService } from "../core/services/identity.service";

export interface CrudService<T> {
    endpoint: string;
    http: HttpClient;

    save(model: T): Observable<T>;
    update(model: T): Observable<T>;
    delete(id: number): Observable<T>;
    get(id: number): Observable<T>;
    getList(): Observable<T[]>;
}


export class CrudService<T> implements CrudService<T> {

    constructor(public endpoint: string, public http: HttpClient, public identityService: IdentityService) {
    }

    save(data: T): Observable<any> {
        let headers = this.identityService.getToken();

        return this.http.post(this.endpoint, data, { headers: headers });
    }
    update(data: T): Observable<any> {
        let headers = this.identityService.getToken();

        return this.http.put(this.endpoint, data, { headers: headers });
    }
    delete(id: number): Observable<any> {
        let headers = this.identityService.getToken();

        return this.http.delete(this.endpoint + '/' + id, { headers: headers });
    }
    get<T>(id: number): Observable<T> {
        let headers = this.identityService.getToken();

        return this.http.get<T>(this.endpoint + "/" + id, { headers: headers });
    }
    getList<T>(): Observable<T[]> {
        let headers = this.identityService.getToken();

        return this.http.get<T[]>(this.endpoint, { headers: headers });
    }
}